(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const gsap = window.gsap;
  if (!gsap) {
      console.error("GSAP library not loaded.");
      return;
  }

  const topTrack = document.querySelector(".about-marquee-top .about-marquee-track");
  const bottomTrack = document.querySelector(".about-marquee-bottom .about-marquee-track");
  const topMarqueeContainer = document.querySelector(".about-marquee-top");
  const bottomMarqueeContainer = document.querySelector(".about-marquee-bottom");
  const heading = document.querySelector(".about-marquee-heading");
  
  const scrollSpeed = 35; // Speed in seconds for one full loop
  const entranceDuration = 1.0; 

  /* ----------------------------------------------------
    1. MARQUEE SCROLL AND APPEARANCE ANIMATIONS
  ---------------------------------------------------- */

  // 1. TOP MARQUEE: Right-to-Left (Scroll + Entrance)
  if (topTrack && topMarqueeContainer) {
    // Entrance
    gsap.to(topMarqueeContainer, { 
        scale: 1, 
        opacity: 1, 
        duration: entranceDuration, 
        ease: "power2.out", 
        delay: 0.2 
    });
    
    // Seamless Scroll (x: 0% to x: -50%)
    gsap.fromTo(
      topTrack,
      { x: '0%' }, 
      {
        x: '-50%', 
        duration: scrollSpeed,
        ease: 'linear',
        repeat: -1,
        immediateRender: false,
        delay: 0.2 // Starts scroll with the entrance
      }
    );
  }

  // 2. BOTTOM MARQUEE: Left-to-Right (Scroll + Entrance)
  if (bottomTrack && bottomMarqueeContainer) {
    // Entrance
    gsap.to(bottomMarqueeContainer, { 
        scale: 1, 
        opacity: 1, 
        duration: entranceDuration, 
        ease: "power2.out", 
        delay: 0.4 
    });
    
    // Seamless Scroll (x: -50% to x: 0%)
    gsap.fromTo(
      bottomTrack,
      { x: '-50%' }, // Start offset
      {
        x: '0%', // End position
        duration: scrollSpeed,
        ease: 'linear',
        repeat: -1,
        immediateRender: false,
        delay: 0.4 // Starts scroll with the entrance
      }
    );
  }

  /* ----------------------------------------------------
    2. HEADING WORD ANIMATION
  ---------------------------------------------------- */
  if (heading) {
    const words = heading.textContent.split(" ");
    
    // Split text into nested spans for the overflow/slide effect
    heading.innerHTML = words
      .map(w => `<span class="word-wrapper"><span class="word-inner">${w}</span></span>`)
      .join(" ");

    const innerWords = heading.querySelectorAll(".word-inner");
    
    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    // A) Reveal the H1 container (from opacity: 0 set in CSS)
    tl.set(heading, { opacity: 1 }, 0.4); 

    // B) Staggered word animation (from yPercent: 100 up to 0)
    tl.from(innerWords, {
      yPercent: 100,
      duration: 0.9,
      stagger: 0.06
    }, 0.4); // Starts simultaneously with the H1 reveal
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // IMPORTANT: use the exact id used in the section HTML
    const carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;

    const slides = Array.from(carousel.querySelectorAll('.carousel-slide'));
    const dots = Array.from(carousel.querySelectorAll('.carousel-dot'));
    const prev = carousel.querySelector('.carousel-prev');
    const next = carousel.querySelector('.carousel-next');

    let currentIndex = slides.findIndex((s) => s.classList.contains('is-active'));
    if (currentIndex === -1) currentIndex = 0;

    let interval = null;
    const autoplayDelay = 5000;

    function setActiveDot(index) {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    function showSlide(index, { animate = true } = {}) {
      const newIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === newIndex);
      });
      currentIndex = newIndex;
      if (dots.length) setActiveDot(currentIndex);
    }

    function nextSlide() {
      showSlide(currentIndex + 1);
    }
    function prevSlide() {
      showSlide(currentIndex - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      interval = setInterval(nextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      if (interval !== null) {
        clearInterval(interval);
        interval = null;
      }
    }

    // Event listeners for controls (guard against absence)
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        nextSlide();
        stopAutoplay();
      });
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        prevSlide();
        stopAutoplay();
      });
    }

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        showSlide(idx);
        stopAutoplay();
      });
    });

    // Pause on hover/focus for accessibility
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    // Keyboard navigation (left / right)
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        nextSlide();
        stopAutoplay();
      }
      if (e.key === 'ArrowLeft') {
        prevSlide();
        stopAutoplay();
      }
    });

    // Ensure the first slide/dot is set correctly on init
    showSlide(currentIndex, { animate: false });

    // Start autoplay only if more than 1 slide
    if (slides.length > 1) startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('site-header');
    if (!header) return;
    const burger = header.querySelector('.header-burger');
    const mobile = header.querySelector('#mobile-menu');

    burger?.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', (!expanded).toString());
      if (mobile) {
        const show = !mobile.hidden;
        mobile.hidden = show;
      }
    });

    // close mobile menu on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobile && !mobile.hidden) mobile.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
